<template>
  <div v-cloak>
    <div class="block">
      <template v-if="[
          'ROLE_ADMIN',
          'ROLE_VNII',
          'ROLE_MINTRUD',
          'ROLE_REGIONAL_AGENCY',
          ].includes($user.role)"
      >
        <h3>
          Федеральные отчеты
        </h3>

        <div class="report-list">
          <div class="report-list__item">
            <div class="report-list__title">
              <span>
                Исходные данные и показатели деятельности органов занятости в разрезе субъектов Российской Федерации за {{ period.name }}
              </span>
            </div>
            <a @click="downloadAsync({
              reportId: 1,
              periodCode: period.code,
              ...($user.role === 'ROLE_REGIONAL_AGENCY' ? { regionCode: regionAndDepartmentInfo.region.code } : {})
            })">
              <div class="report-list__download"></div>
            </a>
          </div>

          <div class="report-list__item">
            <div class="report-list__title">
              <span>
                Заполнение разделов исходных данных в разрезе субъектов Российской Федерации за {{ period.name }}, %
              </span>
            </div>
            <a @click="downloadAsync({
              reportId: 3,
              periodCode: period.code,
              ...($user.role === 'ROLE_REGIONAL_AGENCY' ? { regionCode: regionAndDepartmentInfo.region.code } : {})
            })">
              <div class="report-list__download"></div>
            </a>
          </div>

          <v-expansion-panels>
            <v-expansion-panel class="level2">
              <v-expansion-panel-header>
                <div class="report-list__item" style="margin-top: -12px">
                  <a class="report-list__title">
                    <button class="toggleSwitch">
                      <svg class="closed" fill="none" height="24" viewBox="0 0 24 24"
                           width="24"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                      </svg>
                      <svg class="opened" fill="none" height="24" viewBox="0 0 24 24"
                           width="24"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                      </svg>
                    </button>
                    <span>Отчеты по отдельным показателям</span>
                  </a>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panels class="pl-5" style="margin-top: -12px">
                  <v-expansion-panel v-for="indicator in indicators" :key="'indicator_' + indicator.id">
                    <v-expansion-panel-header>
                      <div class="report-list__item">
                        <a class="report-list__title">
                          <button class="toggleSwitch">
                            <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                            </svg>
                            <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                            </svg>
                          </button>
                          <span>
                            {{ indicator.code }}. {{ indicator.name }}, {{ indicator.unit }} в разрезе субъектов Российской Федерации за {{ period.name }}
                          </span>
                        </a>

                        <a @click.stop="downloadAsync({
                          reportId: 5,
                          indicatorId: indicator.id,
                          periodCode: period.code,
                          ...($user.role === 'ROLE_REGIONAL_AGENCY' ? { regionCode: regionAndDepartmentInfo.region.code } : {})
                        })">
                          <div class="report-list__download"></div>
                        </a>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <div
                          class="report-list__item pl-14"
                          v-for="sourceIndicator in indicator.sourceIndicators"
                          :key="'source_indicator_' + sourceIndicator.id"
                      >
                        <div class="report-list__title">
                          <span>
                            {{ sourceIndicator.code }}. {{ sourceIndicator.name }}, {{ sourceIndicator.unit }} в разрезе субъектов Российской Федерации за {{ period.name }}
                          </span>
                        </div>

                        <a @click.stop="downloadAsync({
                          reportId: 5,
                          indicatorId: sourceIndicator.id,
                          periodCode: period.code,
                          ...($user.role === 'ROLE_REGIONAL_AGENCY' ? { regionCode: regionAndDepartmentInfo.region.code } : {})
                        })">
                          <div class="report-list__download"></div>
                        </a>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>

      <template v-if="[
          'ROLE_ADMIN',
          'ROLE_VNII',
          'ROLE_MINTRUD',
          'ROLE_REGIONAL_AGENCY',
          'ROLE_REGIONAL_ADMINISTRATOR',
          'ROLE_CZN_MANAGER',
          ].includes($user.role)"
      >
        <h3>
          Региональные отчеты ({{ regionAndDepartmentInfo.region.name }})
        </h3>

        <div class="report-list">
          <div class="report-list__item">
            <div class="report-list__title">
              <span>
                Исходные данные и показатели деятельности ЦЗН {{ regionAndDepartmentInfo.region.name }} за {{ period.name }}
              </span>
            </div>
            <a @click="downloadAsync({
              reportId: 2,
              periodCode: period.code,
              regionCode: regionAndDepartmentInfo.region.code,
            })">
              <div class="report-list__download"></div>
            </a>
          </div>

          <div class="report-list__item">
            <div class="report-list__title">
              <span>
                Заполнение разделов исходных данных в разрезе ЦЗН {{ regionAndDepartmentInfo.region.name }} за {{ period.name }}, %
              </span>
            </div>
            <a @click="downloadAsync({
              reportId: 4,
              periodCode: period.code,
              regionCode: regionAndDepartmentInfo.region.code,
            })">
              <div class="report-list__download"></div>
            </a>
          </div>

          <v-expansion-panels>
            <v-expansion-panel class="level2">
              <v-expansion-panel-header>
                <div class="report-list__item" style="margin-top: -12px">
                  <a class="report-list__title">
                    <button class="toggleSwitch">
                      <svg class="closed" fill="none" height="24" viewBox="0 0 24 24"
                           width="24"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                      </svg>
                      <svg class="opened" fill="none" height="24" viewBox="0 0 24 24"
                           width="24"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                      </svg>
                    </button>
                    <span>Отчеты по отдельным показателям</span>
                  </a>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panels class="pl-5" style="margin-top: -12px">
                  <v-expansion-panel v-for="indicator in cznIndicators" :key="'indicator_' + indicator.id">
                    <v-expansion-panel-header>
                      <div class="report-list__item">
                        <a class="report-list__title">
                          <button class="toggleSwitch">
                            <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                            </svg>
                            <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                            </svg>
                          </button>
                          <span>
                            {{ indicator.code }}. {{ indicator.name }}, {{ indicator.unit }} в разрезе ЦЗН {{ regionAndDepartmentInfo.region.name }} за {{ period.name }}
                          </span>
                        </a>

                        <a @click="downloadAsync({
                          reportId: 6,
                          indicatorId: indicator.id,
                          periodCode: period.code,
                          regionCode: regionAndDepartmentInfo.region.code,
                        })">
                          <div class="report-list__download"></div>
                        </a>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <div
                          class="report-list__item pl-14"
                          v-for="sourceIndicator in indicator.sourceIndicators"
                          :key="'source_indicator_' + sourceIndicator.id"
                      >
                        <div class="report-list__title">
                          <span>
                            {{ sourceIndicator.code }}. {{ sourceIndicator.name }}, {{ sourceIndicator.unit }} в разрезе ЦЗН {{ regionAndDepartmentInfo.region.name }} за {{ period.name }}
                          </span>
                        </div>

                        <a @click.stop="downloadAsync({
                          reportId: 6,
                          indicatorId: sourceIndicator.id,
                          periodCode: period.code,
                          regionCode: regionAndDepartmentInfo.region.code,
                        })">
                          <div class="report-list__download"></div>
                        </a>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>
    </div>
    <LoaderDialog :show="loading"></LoaderDialog>
  </div>
</template>

<script>
import api from "../../modules/api";
import LoaderDialog from "../elements/LoaderDialog.vue";

export default {
  name: "ActivityMonitorReports",
  components: {LoaderDialog},
  props: ['regionAndDepartmentInfo', 'period', 'configChecklist', 'configIndicators'],
  data: () => ({
    domain: 'activity_monitor',
    loading: false,
    downloadTaskId: null,
  }),
  computed: {
    indicators() {
      // Для каждого показателя добавляем вложенные исходные данные
      const checklist = this.configChecklist;
      const indicators = this.configIndicators;
      const checklistByCode = new Map(
          checklist
              .filter(i => i?.code != null)
              .map(i => [String(i.code).trim().toUpperCase(), i])
      );

      return indicators.map(indicator => {
        const codesInFormula = this.extractCodesFromFormula(indicator?.formula).map(c => String(c).trim().toUpperCase());
        const seen = new Set();
        const uniqueCodes = [];
        for (const c of codesInFormula) {
          if (!seen.has(c)) {
            seen.add(c);
            uniqueCodes.push(c);
          }
        }

        const sourceIndicators = uniqueCodes
            .map(code => checklistByCode.get(code))
            .sort((a, b) => a?.code.localeCompare(b?.code, "ru", { numeric: true }))
            .filter(Boolean);

        return {
          ...indicator,
          sourceIndicators,
        };
      });
    },
    cznIndicators() {
      return this.indicators.filter(item => item.cznSection || item.isOnlyRegional === false);
    },
  },
  methods: {
    extractCodesFromFormula(formula) {
      if (!formula) return [];
      const str = String(formula);
      const matches = str.match(/[A-Za-zА-Яа-яЁё]+[0-9]+(?:\.[0-9]+)*/g);
      return matches || [];
    },
    async downloadAsync(params) {
      try {
        this.loading = true;

        const queryParams = new URLSearchParams({});
        if (params.periodCode) queryParams.append('period', params.periodCode);
        if (params.regionCode) queryParams.append('region_code', params.regionCode);
        if (params.indicatorId) queryParams.append('indicator_id', params.indicatorId);

        const response = (await api.get(`/reports/generate/${this.domain}/${params.reportId}?${queryParams.toString()}`)).payload;
        this.downloadTaskId = response.task_id;
        await this.checkTaskStatus();
      } catch (error) {
        console.error('Error generating report:', error);
        alert('Ошибка при генерации отчета!');
        this.loading = false;
      }
    },
    async checkTaskStatus() {
      try {
        const response = (await api.get(`/reports/status/${this.downloadTaskId}`)).payload;
        if (response.status === 'SUCCESS') {
          await this.downloadFile();
        } else {
          setTimeout(this.checkTaskStatus, 2000);
        }
      } catch (error) {
        console.error('Error checking task status:', error);
        alert('Ошибка при проверке статуса задачи!');
        this.loading = false;
      }
    },
    async downloadFile() {
      try {
        const blob = (await api.get(`/reports/download/${this.downloadTaskId}`, null, 'blob')).payload;
        this.$downloadBlob(blob, `Отчет.xlsx`);
        this.loading = false;
      } catch (error) {
        console.error('Error downloading file:', error);
        alert('Ошибка при скачивании файла!');
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss">
@import "../../styles/main.scss";
.top-progress {
  margin-bottom: 30px;
  display: flex;
  align-items: center;

  > div > div {
    display: flex;
    flex-direction: column;
    height: 280px;
    border-radius: 20px;
    padding: 30px;

    div {
      font-weight: 600;
      font-size: 64px;
      line-height: 100%;
    }

    p {
      margin-top: auto;
      margin-bottom: 0;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 140%;
      color: #1C1C1F;
    }
  }
}

.date-switch {
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  color: #0033A0;
}

.line-wrap {
  border: 1px solid #E8E8E9;
  border-radius: 4px;
}

.list {
  .list-item-wrap {
    padding: 0;
  }

  table {
    margin-bottom: 25px;

    th {
      padding: 5px 20px 5px 0;

      div.v-dialog__container + div {
        height: 24px;
        cursor: pointer;
      }

      span {
        display: flex;
        justify-content: flex-start;
        gap: 3px;
        min-width: min(150px, 20vw);
      }

      &:first-child {
        text-align: center;
        width: 100%;
      }
    }

    td {
      padding: 5px 20px 5px 0;
      border-top: 1px solid #E8E8E9;
      border-bottom: 0;

      & > div {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        svg {
          margin-right: 8px;
          flex-shrink: 0;
          margin-top: 5px;
          width: 20px;
        }

        a {
          white-space: nowrap;
        }
      }
    }

    tr:last-child {
      td {
        border-top: 1px solid #E8E8E9;
      }
    }
  }
}

.report-list {
  border-top: 1px solid #e8e8e9;

  .report-list__item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e9;
    padding: 5px 0;

    .report-list__title {
      .toggleSwitch {
        margin-right: 5px;
      }

      span {
        color: $cblue;
      }

      display: flex;
      flex-flow: row nowrap;
      align-items: center;

    }

    .report-list__download {
      background: url(~@/assets/download.svg) no-repeat center center;
      background-size: contain;
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}

.v-menu__content.menuable__content__active {
  box-shadow: none;
  border: 1px solid #A0A0A0;
  border-radius: 0;

  .downloads {
    border-radius: 0;

    .v-list {
      padding: 0;
      background: #E9E9E9;

      .v-list-item {
        padding: 0;
        min-height: initial;

        .v-list-item__title {
          padding: 4px 8px;
          color: $cblue;
        }
      }
    }
  }
}
</style>
